import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../api/client';
import { endpoints } from '../../../api/endpoints';
import { queryKeys } from '../../../api/queryKeys';
import type { ReceiptPhotoDto } from '../../../types/api';

interface ReceiptPhotosResponse {
  photos: ReceiptPhotoDto[];
}

export function useReceiptPhotos(encId: string | null, options: { enabled?: boolean } = {}) {
  const enabled = (options.enabled ?? true) && Boolean(encId);
  return useQuery<ReceiptPhotoDto[]>({
    queryKey: queryKeys.receipts.photos(encId ?? ''),
    queryFn: async () => {
      const res = await apiClient.get<ReceiptPhotosResponse>(
        endpoints.receipts.photos(encId ?? ''),
      );
      return res.data.photos;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}
